import { render, staticRenderFns } from "./QPageSlider.vue?vue&type=template&id=02287bdb&"
import script from "./QPageSlider.vue?vue&type=script&lang=js&"
export * from "./QPageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports